import Template from './Template'

class SingleOfferTemplate extends Template{
    constructor(props = {}) {
        super(props)
        this.campaign = props.campaign || {}
    }
}
export default SingleOfferTemplate